import React, { Component, Fragment } from 'react';
import DEFINE, { DETAIL_ACTIONS, PATHS } from "constants/Define";
import AntSelect, { AntOption } from "containers/backend/common/component/AntSelect";
import {
    FormActionComponent,
    FormWrapperInputComponent,
    FormWrapperItem,
    HeaderListComponent,
    LoadingComponent,
    PageListComponent
} from "containers/backend/common/component/Index";
import { message } from 'antd';
import i18n from "../../../../../constants/initLng";
import * as Func from '../../../../../helpers/functions';
import Wrapper from "containers/backend/common/component/Wrapper";
import TextArea from 'containers/backend/common/component/TextArea';

let permisionActions = [];
export default class RateCompareDetail extends Component {
    constructor(props) { 
        super(props);
        this.state = {
            filters: {
                hotelId: this.props.match.params.hotel_id,
                pageSize: 1000,
            },
            dataRateCompare: {
                hotelId: this.props.match.params.hotel_id,
                rateCodeCompare: '',
                rateCodePriority: '',
                note: '',
            },
            hotelRate: { hotelId: this.props.match.params.hotel_id },
            action: this.props.match.params.id ? DETAIL_ACTIONS.UPDATE : DETAIL_ACTIONS.CREATE,
            rateList: [],
            rateCompareList: [],
            rateListFilter: [],
            validation: {},
            isGetItem: true,
        }
    }

    componentDidMount() {
        const { getListRateCompare, getListRates } = this.props
        const { filters, hotelRate } = this.state
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATE_COMPARE);
        getListRateCompare(filters);
        getListRates(hotelRate);
    }
    
    componentWillReceiveProps(nextProps) {
        const { hotelState, rateState } = nextProps;
        const rateList = rateState.dataList;
        const rateCompareList = hotelState.rateCompareList;
        const filteredList = rateList.map(rateListItem => {
            const isDisable = rateCompareList.some(compareListItem => {
                return (
                    rateListItem.code === compareListItem.rateCodeCompare ||
                    rateListItem.code === compareListItem.rateCodePriority
                );
            });

            return {
                id: rateListItem.id,
                code: rateListItem.code,
                isDisable: isDisable
            };
        });
        this.setState({ rateList: rateList });
        this.setState({ rateCompareList: rateCompareList });
        this.setState({ rateListFilter: filteredList });
        
        if (this.state.action === DETAIL_ACTIONS.UPDATE){
            const selectedItem = rateCompareList.find(item => item.id === this.props.match.params.id);
            if(selectedItem) {
                this.setState({
                    dataRateCompare: {
                        hotelId: selectedItem.hotelId,
                        rateCodeCompare: selectedItem.rateCodeCompare,
                        rateCodePriority: selectedItem.rateCodePriority,
                        note: selectedItem.note,
                    }
                });
                this.setState({ isGetItem: false });
            }
        }
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props?.children?.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    validation = (field, reload) => {
        const { t } = this.props;
        let dataRateCompare = this.state.dataRateCompare;
        let result = {};
        if (!reload) {
            let validate = {
                required: {
                    rateCodeCompare: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.rateCompare.rateCodeCompare`)),
                    rateCodePriority: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.rateCompare.rateCodePriority`))
                },
            };
            result = Func.multipleValidate(dataRateCompare, validate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    onClickBack = () => {
        const { match, history } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
            const path = Func.getPathWithParams(PATHS.RATE_COMPATE.LIST.path, { hotel_id: match.params.hotel_id })
            history.push(path);
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            const dataRateCompare = this.state.dataRateCompare;
            if (this.state.action === DETAIL_ACTIONS.CREATE) {
                this.props.createRateCompare(dataRateCompare);
            } else if (this.state.action === DETAIL_ACTIONS.UPDATE) {
                this.props.updateRateCompare({
                    dataRateCompare: dataRateCompare,
                    id: this.props.match.params.id,
                });
            } 
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    handleChange = (key, value) => { 
        const { dataRateCompare, rateList, rateCompareList } = this.state;
        const arrValue = value.split(":");
        const newData = {
            ...dataRateCompare,
            [key]: arrValue[0]
        }
        this.setState({ dataRateCompare: newData });

        const updatedFilteredList = rateList.map(rateListItem => {
            const isDisable = rateCompareList.some(compareListItem => {
                return (
                    rateListItem.code === compareListItem.rateCodeCompare ||
                    rateListItem.code === compareListItem.rateCodePriority
                );
            });
            return {
                id: rateListItem.id,
                code: rateListItem.code,
                isDisable: isDisable
            };
        })
        this.setState({ rateListFilter: updatedFilteredList });
        this.validation(key, true)
    }

    handleChangeNote = (e) => {
        const { dataRateCompare } = this.state;
        const newData = {
            ...dataRateCompare,
            note: e.target.value
        }
        this.setState({ dataRateCompare: newData });
    }
    
    render() {
        const { t, match } = this.props;
        const { action, dataRateCompare, rateListFilter, validation, isGetItem } = this.state;

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={match.path}
                        groupPath={'rateCompare'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.rateCompare.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.rateCompare.title')}`.toLowerCase()))
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        action={action}
                        submitButtonRight={true}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.CREATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.CREATE ? t(`action.add`) : t(`action.update`)}
                        isGetItem={isGetItem}
                    >
                        <FormWrapperItem>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    labelTitle={t(`item.rateCompare.rateCodeCompare`)}
                                    isRequired={true}
                                    isValidation={true}
                                    dataValidation={dataRateCompare.rateCodeCompare}
                                    validation={validation.rateCodeCompare}
                                >
                                    <AntSelect className="select-lengthOfTour"
                                        showArrow showSearch
                                        value={dataRateCompare?.rateCodeCompare || ''}
                                        onChange={(value) => this.handleChange('rateCodeCompare', value)}
                                        filterOption={this.selectFilterSearch}
                                        style={{ width: '100%' }}
                                    >
                                        {rateListFilter.map((item) => (
                                            <AntOption
                                                key={item.id}
                                                value={`${item.code}:${item.id}`}
                                                disabled={item.isDisable}
                                            >
                                                {item.code}
                                            </AntOption>
                                        ))}
                                    </AntSelect>
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    labelTitle={t(`item.rateCompare.rateCodePriority`)}
                                    isRequired={true}
                                    isValidation={true}
                                    dataValidation={dataRateCompare.rateCodePriority}
                                    validation={validation.rateCodePriority}
                                >
                                    <AntSelect className="select-lengthOfTour"
                                        showArrow showSearch
                                        value={dataRateCompare?.rateCodePriority || ''}
                                        onChange={(value) => this.handleChange('rateCodePriority', value)}
                                        filterOption={this.selectFilterSearch}
                                        style={{ width: '100%' }}
                                    >
                                        {rateListFilter.map((item) => (
                                            <AntOption
                                                key={item.id}
                                                value={`${item.code}:${item.id}`}
                                                disabled={item.isDisable}
                                            >
                                                {item.code}
                                            </AntOption>
                                        ))}
                                    </AntSelect>
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md">
                                <FormWrapperInputComponent
                                    labelTitle={t(`item.rateCompare.note`)}
                                >
                                    <TextArea
                                        className="form-control" name="note"
                                        onChange={e => this.handleChangeNote(e)}
                                        value={dataRateCompare?.note}
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>
                        </FormWrapperItem>
                    </FormActionComponent>
                </PageListComponent>
            </Fragment>
        )
    }
}